import ChallengeTypes from './ChallengeTypes';

export default ChallengeTypes;
